<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>

    <div class="area_title">
      <h1>{{ contactUs.title }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{
            navbar.home
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ contactUs.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="call_wrap">
      <div class="call_wrap__right flex f-column f-jus-center">
        <div class="call_wrap__title">
          <!-- <h3>{{ contactUs.subTitle1 }}</h3> -->
          <!-- <h3 style="margin-top: 25px;">{{ contactUs.subTitle2 }}</h3> -->
          <h3>{{ contactUs.subTitle2 }}</h3>
        </div>

        <div class="call_wrap__body">
          <div
            class="call_wrap__body-item"
            v-for="(item, i) in contactUs.info_list"
            :key="i"
          >
            <label class="call_wrap__body-label" v-if="item.label">{{ item.label }}</label>
            <div class="call_wrap__body-value" v-html="$convertPxToRem(item.content)"></div>
          </div>
        </div>

        <div class="call_wrap__foot">
          <div>
            <span class="call_wrap__foot-tel">+86-189-6183-2100</span>
            <span class="call_wrap__foot-tip">{{ contactUs.contactTxt }}</span>
          </div>
        </div>

        <div class="call_wrap__body-label" style="max-width:100%;margin-top:10px;line-height:1.8;" v-html="$convertPxToRem(contactUs.qrcodeLabel)"></div>

        <ul class="qrcode_list">
          <li v-for="(item, index) in contactUs.qrcodeList" :key="index" @click="handleNavigate(item)">
            <img class="icon_item" :src="item.icon" alt="" />
          </li>
        </ul>
      </div>

      <div class="leave-msg">
        <div class="leave-msg__head">
          <h3 class="leave-msg__head-title">{{ contactUs.form.title }}</h3>
        </div>
        <div class="leave-msg__sign">
          <h3 class="leave-msg__sign-title">{{ contactUs.form.sign }}</h3>
          <div class="leave-msg_sign-tiptext">
            {{ contactUs.form.tipSign }}
          </div>
        </div>
        <el-form
          :model="leave_form"
          :rules="rules"
          ref="ruleForm"
          class="leave-msg__form"
        >
          <div class="leave-msg__form-item">
            <el-form-item :label="contactUs.form.usernameLabel" prop="username">
              <el-input placeholder="" v-model="leave_form.username"></el-input>
            </el-form-item>
          </div>
          <div class="leave-msg__form-item">
            <el-form-item :label="contactUs.form.businessLabel" prop="business">
              <el-input placeholder="" v-model="leave_form.business"></el-input>
            </el-form-item>
          </div>
          <div class="leave-msg__form-item">
            <div class="leave-msg__form-item-block" style="width: 51%;">
              <el-form-item :label="contactUs.form.telPhoneLabel" prop="tel_phone">
                <el-input placeholder="" v-model="leave_form.tel_phone"></el-input>
              </el-form-item>
            </div>
            <div class="leave-msg__form-item-block" style="width: 49%;">
              <el-form-item :label="contactUs.form.emailLabel" prop="email">
                <el-input placeholder="" v-model="leave_form.email"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="leave-msg__form-item" v-if="false">
            <div class="leave-msg__form-item-block" style="width: 60%;">
              <el-form-item :label="contactUs.form.emailLabel" prop="email">
                <el-input placeholder="" v-model="leave_form.email"></el-input>
              </el-form-item>
              <div
                class="getCode_btn"
                @click.stop="getCode()"
                :style="{ color: getCodeBtnColor }"
              >
                {{ getCodeText }}
              </div>
            </div>
            <div
              class="leave-msg__form-item-block"
              style="width: 40%;white-space: nowrap;"
            >
              <el-form-item
                :label="contactUs.form.emailCodeLabel"
                prop="emailCode"
              >
                <el-input
                  placeholder=""
                  v-model="leave_form.emailCode"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <!-- 职务 -->
          <div class="leave-msg__form-item" v-if="false">
            <el-form-item :label="contactUs.form.dutiesLabel" prop="duties">
              <el-input placeholder="" v-model="leave_form.duties"></el-input>
            </el-form-item>
          </div>
          <!-- 附件 -->
          <div class="leave-msg__form-item" style="display: inline-table;" v-if="false">
            <div
              class="el-input-group__prepend"
              style="font-size: 14px;line-height:46px ;"
            >
              {{ contactUs.form.uploadLabel }}
            </div>
            <div
              class="el-input__inner"
              style="display: flex; align-items: center;position: relative;"
            >
              <el-upload
                multiple
                :action="uploadFileUrl"
                :before-upload="handleBeforeUpload"
                :file-list="fileList"
                :limit="limit"
                :on-error="handleUploadError"
                :on-exceed="handleExceed"
                :on-success="handleUploadSuccess"
                :show-file-list="false"
                class="upload-file-uploader"
                ref="fileUpload"
              >
                <!-- 上传按钮 -->
                <el-button size="mini" type="primary">{{
                  contactUs.form.uploadPlaceholder
                }}</el-button>
                <!-- 上传提示 -->
                <div class="el-upload__tip" slot="tip">
                  请上传
                  <template v-if="fileSize">
                    大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
                  </template>
                  <template v-if="fileType">
                    格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b>
                  </template>
                  的文件
                </div>
              </el-upload>
              <transition-group
                class="upload-file-list el-upload-list el-upload-list--text"
                name="el-fade-in-linear"
                tag="ul"
              >
                <li
                  :key="file.url"
                  class="el-upload-list__item ele-upload-list__item-content"
                  v-for="(file, index) in fileList"
                >
                  <el-link
                    :href="`${baseUrl}${file.url}`"
                    :underline="false"
                    target="_blank"
                  >
                    <span class="el-icon-document">
                      {{ file.name }}
                    </span>
                  </el-link>
                  <!-- <div class="ele-upload-list__item-content-action">
                    <el-link
                      :underline="false"
                      @click="handleDelete(index)"
                      type="danger"
                      >删除</el-link
                    >
                  </div> -->
                </li>
              </transition-group>
            </div>
          </div>
          <div class="leave-msg__form-textarea leave-msg__form-item">
            <el-form-item label="" prop="leave_content">
              <el-input
                type="textarea"
                show-word-limit
                resize="none"
                :placeholder="contactUs.form.leaveContentPlaceholder"
                v-model="leave_form.leave_content"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>

        <div class="eave-msg__form-submit-btn flex f-column f-center">
          <el-button :loading="isSubmiting" @click="handleFormSubmit('ruleForm')">{{
            contactUs.form.submitBtn
          }}</el-button>
        </div>
      </div>
    </div>

    <!-- <div class="address_wrap flex f-jus-end">
      <div id="map_wrapper">
        <img src="../../../assets/images/public/map.png" alt="">
      </div>
    </div> -->

    
    <div class="foot flex f-jus-between">
      <div class="foot-item" v-for="(item, i) in contactUs.group1" :key="i">
        <h3 class="foot-item__title">{{ item.title }}</h3>
        <p class="foot-item__paragraph">
          {{ item.content }}
        </p>
        <div class="foot-item__btn" @click="towangluo(item.path)">
          <span>{{ item.button }}</span>
        </div>
      </div>
    </div>

    <footer-wrap></footer-wrap>

    <verification-code ref="verificationCodeRef" @on-submit="handleCodeSubmit"></verification-code>
    <message-success-modal ref="messageSuccessModalRef"></message-success-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { postAdvise, sendEmail, checkemail, checkEmailApi } from "@/utils/http.js";
import VerificationCode from './verification_code.vue'
import MessageSuccessModal from './success_modal.vue'

export default {
  components: {
    VerificationCode,
    MessageSuccessModal
  },

  data() {
    return {
      number: 0,
      uploadList: [],
      baseUrl: "https://miniapp.kelkflow.com",
      fileList: [],
      fileSize: 500,
      uploadFileUrl: "https://miniapp.kelkflow.com" + "/api/common/upload",
      fileType: ["doc", "xls", "ppt", "txt", "pdf", "jpg"],
      limit: 2,
      getCodeText: "获取验证码",
      getCodeBtnColor: "#999999",
      isSubmiting: false,
      leave_form: {
        username: "",
        business: "",
        tel_phone: "",
        email: "",
        emailCode: "",
        // duties: "",
        leave_content: ""
      },
      getCodeisWaiting: false,
      rules: {
        username: [{ required: true, message: "Please enter your name", trigger: "blur" }],
        business: [{ required: true, message: "Please enter company", trigger: "blur" }],
        tel_phone: [
          { required: true, message: "Please enter a contact number", trigger: "blur" }
        ],
        email: [{ required: true, message: "Please enter email", trigger: "blur" }],
        emailCode: [
          { required: true, message: "Please enter your email verification code", trigger: "blur" }
        ],
        leave_content: [
          { required: true, message: "Please enter the message content", trigger: "blur" }
        ]
      }
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    navbar() {
      return this.currentLang.config.navbar;
    },
    contactUs() {
      return this.currentLang.config.contactUs;
    }
  },

  mounted() {
    // this.$refs.messageSuccessModalRef.open()
    // this.initMap()
  },

  methods: {
    handleNavigate(info) {
      info && info.link && window.open(info.link)
    },

    initMap() {
      const map = new BMapGL.Map("map_wrapper");
      map.centerAndZoom(new BMapGL.Point(120.49891, 31.51161), 18);
      map.enableScrollWheelZoom(true);
      map.addOverlay(new BMapGL.Marker(new BMapGL.Point(120.49916, 31.51180)));
    },

    joinIn() {
      this.$router.push("/joinIn");
    },
    towangluo(path) {
      if (path == '/about') {
        this.$router.push({ path: "/about", query: { index: "3" } })
        return
      }
      this.$router.push(path)
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      console.log(file);
      // 校检文件类型
      if (this.fileType) {
        const fileName = file.name.split(".");
        const fileExt = fileName[fileName.length - 1];

        let isTypeOk = false;
        if (this.fileType.indexOf(fileExt) >= 0) {
          isTypeOk = true;
        } else {
          isTypeOk = false;
        }
        if (!isTypeOk) {
          this.$message.warning(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        let isLt = false;
        if (file.size / 1024 / 1024 < this.fileSize) {
          isLt = true;
        } else {
          isLt = false;
        }
        if (!isLt) {
          this.$message.warning(`上传文件大小不能超过 ${this.fileSize} MB!`);
          // this.$modal.msgError(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      this.$message.success("正在上传文件，请稍候...");
      this.number++;
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$message.warning(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.warning("上传文件失败，请重试");
      // this.$modal.closeLoading();
    },
    // 文件个数超出
    handleExceed() {
      this.$message.warning(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传文件失败，请重试");
      // this.$modal.closeLoading();
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      if (res.code === 1) {
        // console.log(file)
        this.uploadList.push({ name: file.name, url: res.data.fullurl });
        this.uploadedSuccessfully();
      } else {
        this.number--;
        this.$message.error(res.msg);
        this.$refs.fileUpload.handleRemove(file);
        this.uploadedSuccessfully();
      }
    },
    // 删除文件
    // handleDelete(index) {
    //   const customerno = this.customerno;
    //   this.$confirm("是否确认删除此附件？")
    //     .then(function() {
    //       // 后端删除接口
    //       // return delAttachment(customerno);
    //     })
    //     .then(() => {
    //       // 删除文件列表
    //       this.fileList.splice(index, 1);
    //       this.$modal.msgSuccess("删除成功");
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });

    //   // this.$emit("input", this.listToString(this.fileList));
    // },
    // 上传结束处理
    uploadedSuccessfully() {
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList);
        this.uploadList = [];
        this.number = 0;
        // this.$emit("input", this.listToString(this.fileList));
        // this.$modal.closeLoading();
      }
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1);
      } else {
        return "";
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != "" ? strs.substr(0, strs.length - 1) : "";
    },

    handleFormSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          checkEmailApi({ email: this.leave_form.email }).then(res => {
            if (res.code === 1) {
              if (res.data) {
                this.submitForm(this.leave_form)
              }
              else {
                this.$refs.verificationCodeRef.open(this.leave_form)
              }
            }
            else {
              this.$message.error(res.msg);
            }
          });
        }
        else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCodeSubmit(formData) {
      this.$refs.verificationCodeRef.isSubmiting = true
      this.submitForm(formData)
    },
    // 提交留言
    submitForm(query) {
      this.isSubmiting = true
      let pictureList = [];
      pictureList = this.fileList.map((item, index, arr) => {
        return item.url;
      });
      const params = {
        type_id: 13,
        content: query.leave_content,
        email: query.email,
        email_code: query.emailCode,
        name: query.username,
        phone: query.tel_phone,
        company_name: query.business
      }

      postAdvise(params).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.$message.success(res.msg);
          this.leave_form = {
            username: "",
            business: "",
            tel_phone: "",
            email: "",
            emailCode: "",
            duties: "",
            leave_content: ""
          };
          this.fileList = [];
          this.$refs.verificationCodeRef.close()
          this.$refs.messageSuccessModalRef.open(res.data)
        }
      })
      .catch(err => {
        err.msg && this.$message.error(err.msg)
      })
      .finally(() => {
        this.$refs.verificationCodeRef.isSubmiting = false
        this.isSubmiting = false
      })
    },

    getCode() {
      if (this.getCodeisWaiting) {
        return;
      }
      this.getCodeText = "发送中..."; //发送验证码
      sendEmail({ email: this.leave_form.email })
        .then(res => {
          if (res.code === 1) {
            this.getCodeisWaiting = true;
            this.$message.success("验证码已发送,请到邮箱查看");
            setTimeout(() => {
              this.setTimer(); //调用定时器方法
            }, 1000);
          }
        })
        .catch(err => {
          this.$message.error("获取失败，请检查后重新获取！")
          this.resetCodeInfo()
        })
    },
    setTimer() {
      let holdTime = 60; //定义变量并赋值
      this.getCodeText = "重新获取(60)";
      //setInterval（）是一个实现定时调用的函数，可按照指定的周期（以毫秒计）来调用函数或计算表达式。
      //setInterval方法会不停地调用函数，直到 clearInterval被调用或窗口被关闭。
      this.Timer = setInterval(() => {
        if (holdTime <= 0) {
          this.resetCodeInfo()
          return; //返回前面
        }
        this.getCodeText = "重新获取(" + holdTime + ")";
        holdTime--;
      }, 1000);
    },
    resetCodeInfo() {
      this.getCodeisWaiting = false;
      this.getCodeBtnColor = "#999999";
      this.getCodeText = "获取验证码";
      clearInterval(this.Timer); //清除该函数
    }
  }
};
</script>

<style lang="scss" scoped>
.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
  }
  .breadcrumb_wrap {
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}
.call_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 40px 40px;
  margin: 40px auto;
  display: flex;
  // align-items: center;
  justify-content: center;
  background-color: #f9f9f9;

  .call_wrap__right {
    padding-right: 50px;
    // width: 450px;
    max-width: 540px;
    height: 100%;
  }

  .call_wrap__title h3 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 2px;
  }

  .call_wrap__body {
    margin: 30px 0 16px;
    // margin: 176px 0 30px;
  }

  .call_wrap__body-item {
    display: flex;
    margin-top: 14px;
    // margin-top: 20px;
  }
  .call_wrap__body-item:first-child {
    margin-top: 0;
  }

  .call_wrap__body-label {
    
    max-width: 150px;
    color: #333;
    font-size: 16px;
    font-weight: 600;
  }

  .call_wrap__body-value {
    color: #666;
    flex: 1;
  }

  .call_wrap__foot-tel {
    margin: 0 20px 0 0;
    font-size: 24px;
    font-weight: 600;
    color: #d71a21;
  }

  .call_wrap__foot-tip {
    color: #999;
  }
}

.address_wrap {
  margin: 40px auto;
  width: 100%;
  // width: 1200px;
  // height: 450px;
  overflow: hidden;

  #map_wrapper {
    width: 100%;
    height: 100%;
    img{
      width: 100%;
      height: auto;
    }
  }
}

.qrcode_list {
  margin: 10px 0 0;
  display: flex;
  
  li {
    margin-right: 30px;
    cursor: pointer;

    img,
    span {
      display: block;
      text-align: center;
      color: #666;
    }
    .icon_item {
      width: 70px;
      height: 70px;
      margin: 0 auto;
      transition: all 1s;
    }
    .qr_code {
      width: 130px;
      height: 130px;
      margin: 4px auto 5px;
    }

    .lx_dialog1 {
      width: 140px;
      height: auto;
      color: black;
      padding: 5px;
      text-align: center;
      background: white;
      font-size: 14px;
      border-radius: 5px;
      position: absolute;
      bottom: 56px;
      left: -21px;
    }
  }
}

.qrcode_wrap {
  width: 1200px;
  margin: 75px auto 0;
  display: flex;
  justify-content: space-between;
  li {
    img,
    span {
      display: block;
      text-align: center;
      color: #666;
    }
    .icon_item {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      margin: 0 auto;
      transition: all 1s;
    }
    .qr_code {
      width: 130px;
      height: 130px;
      margin: 30px auto;
    }
  }
}

.leave-msg {
  height: auto;
  width: 760px;
  // background-color: #00a4ff;

  .leave-msg__head {
    margin-bottom: 30px;
  }

  .leave-msg__head-title {
    color: #333;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 2px;
    text-align: center;
  }

  .leave-msg__sign {
    margin-bottom: 30px;
  }

  .leave-msg__sign-title {
    color: #000;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 2px;
    text-align: justify;
    text-align-last: center;
    
  }

  .leave-msg_sign-tiptext {
    margin-top: 5px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #666;
    color: #00335a;
  }

  .leave-msg__form {
    .leave-msg__form-item {
      width: 48%;
      width: 100%;
      margin-bottom: 20px;
      border: 2px solid #ddd;
      display: flex;
      .el-form-item {
        width: 100%;
        margin-bottom: 0;
        display: flex;
      }
      /deep/ .el-form-item__label {
        padding: 0 20px !important;
        line-height: 48px;
        white-space: nowrap;
      }
      /deep/ .el-form-item__content {
        line-height: 40px;
        position: relative;
        font-size: 14px;
        width: 100%;
      }
      .leave-msg__form-item-block {
        display: flex;
        align-items: center;
      }
      .getCode_btn {
        font-size: 14px;
        white-space: nowrap;
        cursor: pointer;
      }
    }

    .leave-msg__form-textarea {
      width: 100%;
      margin-bottom: 30px;
    }
    /deep/ .el-input-group__prepend {
      background-color: #fff;
      border: 0;
      border-radius: 0;
      color: #606266;
    }

    /deep/ .el-input__inner {
      border: 0;
      border-radius: 0;
      height: calc(50px - 4px);
      line-height: 46px;
      display: block;
    }

    /deep/ .el-textarea__inner {
      border: 0;
      border-radius: 0;
      height: calc(150px - 4px);
    }
    /deep/ .el-upload-list__item {
      line-height: normal;
      margin-left: 10px;
      margin-top: 0px !important;
    }
    /deep/ .el-upload__tip {
      font-size: 12px;
      color: #606266;
      margin-top: 7px;
      position: absolute;
      bottom: -34px;
    }
  }

  .eave-msg__form-submit-btn {
    /deep/ .el-button {
      width: 120px;
      height: 46px;
      border: 0;
      border-radius: 8px;
      background-color: #003359;
      color: #fff;
      font-size: 16px;
      letter-spacing: 2px;
    }
  }
}

.foot {
  width: 1200px;
  margin: 0 auto 90px;
  background-color: #fff;

  .foot-item {
    position: relative;
    width: calc(50% - 80px);
    height: auto;
    padding: 30px;
    background-color: #f5f5f5;
  }

  .foot-item__title {
    margin-bottom: 26px;
    color: #333;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 1px;
  }

  .foot-item__paragraph {
    min-height: 90px;
    margin-bottom: 30px;
    color: #777;
    text-align: justify;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .foot-item__btn {
    position: relative;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 170px;
    height: auto;
    padding: 10px 0;
    background-color: #e8363e;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
  }
}
</style>


<style scoped>
/deep/ .el-form-item__label {
    display: flex;
    flex-direction: row-reverse;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  margin-left: 4px;
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/callMe/modules/callMe_en.vue